<template>
  <div class="about-page">
    <!-- 背景装饰 -->
    <div class="ambient">
      <div class="ambient-orb orb-a"></div>
      <div class="ambient-orb orb-b"></div>
      <div class="ambient-orb orb-c"></div>
      <div class="ambient-grid"></div>
    </div>

    <div class="about-wrap">
      <!-- Hero -->
      <header class="about-hero">
        <div class="hero-badge">关于我们</div>
        <h1 class="hero-title">
          <span class="title-word">格瑞创新</span>
          <span class="title-accent">动漫平台</span>
        </h1>
        <p class="hero-lead">
          致力于打造高品质的漫画阅读与创作生态，连接创作者与读者，让每一部作品都被看见。
        </p>
      </header>

      <!-- 公司简介 -->
      <section class="about-card company-card">
        <div class="company-header">
          <div class="brand-mark">G</div>
          <div class="company-meta">
            <h2 class="company-name">北京格瑞创新科技有限公司</h2>
            <span class="company-tag">动漫内容服务平台</span>
          </div>
        </div>
        <div class="company-body">
          <p>
            格瑞创新动漫平台是一个集漫画阅读、创作投稿、会员服务、金币充值于一体的综合性动漫内容服务平台。我们汇聚海量优质漫画作品，为用户提供流畅舒适的阅读体验，同时扶持原创作者，构建健康可持续的动漫创作生态。
          </p>
          <p>
            平台始终将用户体验与内容质量放在首位，通过技术创新不断打磨产品细节，为广大漫画爱好者和创作者创造更大价值。
          </p>
        </div>
      </section>

      <!-- 数据亮点 -->
      <section class="stats-section">
        <div class="stats-grid">
          <div class="stat-card" v-for="(stat, i) in stats" :key="i">
            <div class="stat-icon" v-html="stat.icon"></div>
            <div class="stat-number">{{ stat.value }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </section>

      <!-- 服务承诺 -->
      <section class="about-card promise-card">
        <h2 class="section-title">我们的承诺</h2>
        <div class="promise-list">
          <div class="promise-item" v-for="(item, i) in promises" :key="i">
            <div class="promise-marker"></div>
            <div class="promise-content">
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 适龄提示 -->
      <section class="about-card age-card">
        <h2 class="section-title">适龄提示</h2>
        <div class="age-summary">
          <div class="age-badge">16+</div>
          <div class="age-summary-text">
            <p>依据《未成年人网络保护条例》及网络游戏/内容适龄提示相关标准，本平台内容适合 <b>16周岁以上</b> 用户使用。</p>
          </div>
        </div>
        <div class="age-detail">
          <p>1. 平台内容可能包含适量情节冲突与战斗描写，不含违法违规及严重不适宜未成年人内容。</p>
          <p>2. 未成年人使用本平台，建议在监护人指导下开启<b>青少年模式</b>，平台将限制使用时长与夜间时段（默认22:00-6:00）、连续使用满30分钟提醒休息、并禁止充值消费。</p>
          <p>3. 监护人应加强对未成年人使用网络行为的引导和监督，合理安排使用时间，预防沉迷。平台依据《未成年人网络保护条例》建立<b>防沉迷制度</b>，不设置应援集资、投票打榜、刷量控评等功能。</p>
          <p>4. 平台设立<b>未成年人保护投诉举报渠道</b>：客服电话 13810795803。发现危害未成年人身心健康的内容或功能，或未成年人未经监护人同意充值消费的，可随时投诉举报，平台将及时核实处置。</p>
        </div>
      </section>

      <!-- 联系信息 -->
      <section class="about-card contact-card">
        <h2 class="section-title">联系我们</h2>
        <div class="contact-grid">
          <div class="contact-item">
            <div class="contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            </div>
            <div class="contact-info">
              <span class="contact-label">客服电话</span>
              <span class="contact-value">13810795803</span>
            </div>
          </div>
          <div class="contact-item">
            <div class="contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
            </div>
            <div class="contact-info">
              <span class="contact-label">公司地址</span>
              <span class="contact-value">北京市朝阳区北辰东路8号院16号楼4层A406</span>
            </div>
          </div>
          <div class="contact-item">
            <div class="contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
            </div>
            <div class="contact-info">
              <span class="contact-label">官方网站</span>
              <span class="contact-value">www.comicshort.cn</span>
            </div>
          </div>
        </div>
      </section>

      <footer class="about-footer">
        最后更新日期：2026年1月1日
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  data() {
    return {
      stats: [
        { icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>', value: '海量', label: '优质漫画' },
        { icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>', value: '创作者', label: '原创扶持' },
        { icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>', value: '全天候', label: '稳定服务' },
        { icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>', value: '高品质', label: '阅读体验' }
      ],
      promises: [
        { title: '正版内容', desc: '坚持正版授权，保护创作者权益，为用户提供高质量的漫画内容。' },
        { title: '青少年保护', desc: '提供青少年保护模式，合理管控使用时长与消费行为，守护未成年人健康成长。' },
        { title: '隐私安全', desc: '采用加密传输与安全存储，严格保护用户个人信息与账号安全。' },
        { title: '持续创新', desc: '不断优化产品体验与内容生态，为创作者和读者创造更大价值。' }
      ]
    }
  }
}
</script>

<style scoped>
.about-page {
  position: relative;
  min-height: 100vh;
  padding: 48px 20px 64px;
  background: var(--bg);
  color: var(--text);
  overflow: hidden;
}

/* 背景氛围 */
.ambient {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.ambient-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: .28;
}

.orb-a {
  width: 420px;
  height: 420px;
  top: -120px;
  right: -80px;
  background: #4facfe;
  animation: float 12s ease-in-out infinite;
}

.orb-b {
  width: 320px;
  height: 320px;
  bottom: 10%;
  left: -100px;
  background: #00f2fe;
  animation: float 14s ease-in-out infinite reverse;
}

.orb-c {
  width: 260px;
  height: 260px;
  top: 45%;
  right: 10%;
  background: #7dd3fc;
  opacity: .18;
  animation: float 16s ease-in-out infinite;
}

.ambient-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, .04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, .04) 1px, transparent 1px);
  background-size: 60px 60px;
  mask-image: radial-gradient(ellipse at center, black 0%, transparent 75%);
  -webkit-mask-image: radial-gradient(ellipse at center, black 0%, transparent 75%);
}

@keyframes float {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(12px, -18px) scale(1.04); }
}

.about-wrap {
  position: relative;
  z-index: 1;
  max-width: 880px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 28px;
}

/* 通用卡片 */
.about-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: var(--radius-lg);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  padding: 32px;
  transition: transform .25s ease, border-color .25s ease, background .25s ease;
}

.about-card:hover {
  transform: translateY(-3px);
  border-color: rgba(255, 255, 255, 0.22);
  background: rgba(255, 255, 255, 0.11);
}

/* Hero */
.about-hero {
  text-align: center;
  padding: 28px 0 12px;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 6px 14px;
  border-radius: var(--radius-pill);
  background: rgba(79, 172, 254, 0.18);
  border: 1px solid rgba(79, 172, 254, 0.35);
  color: #bfe3ff;
  margin-bottom: 18px;
}

.hero-title {
  font-size: clamp(36px, 6vw, 58px);
  font-weight: 800;
  line-height: 1.15;
  margin: 0 0 16px;
  letter-spacing: -0.02em;
}

.title-word {
  display: block;
  background: linear-gradient(135deg, #ffffff 0%, #bfecff 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.title-accent {
  display: block;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.72);
  font-size: .62em;
  letter-spacing: 4px;
  margin-top: 6px;
}

.hero-lead {
  max-width: 560px;
  margin: 0 auto;
  font-size: 16px;
  line-height: 1.7;
  color: var(--text-dim);
}

/* 公司卡片 */
.company-header {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 20px;
}

.brand-mark {
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  box-shadow: 0 8px 24px rgba(79, 172, 254, 0.32);
}

.company-name {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 4px;
}

.company-tag {
  font-size: 13px;
  color: var(--text-faint);
  border: 1px solid var(--border);
  padding: 3px 10px;
  border-radius: var(--radius-pill);
  background: rgba(255, 255, 255, 0.06);
}

.company-body p {
  font-size: 15px;
  line-height: 1.85;
  color: var(--text-dim);
  margin: 0 0 14px;
}

.company-body p:last-child {
  margin-bottom: 0;
}

/* 数据网格 */
.stats-section {
  width: 100%;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: var(--radius);
  padding: 22px 14px;
  text-align: center;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  transition: transform .2s ease, background .2s ease, border-color .2s ease;
}

.stat-card:hover {
  transform: translateY(-4px);
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.2);
}

.stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(79, 172, 254, 0.16);
  border: 1px solid rgba(79, 172, 254, 0.3);
  color: #bfe3ff;
  margin-bottom: 12px;
}

.stat-icon svg {
  width: 22px;
  height: 22px;
}

.stat-number {
  font-size: 18px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 13px;
  color: var(--text-faint);
}

/* 承诺 */
.section-title {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 22px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.promise-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
}

.promise-item {
  display: flex;
  gap: 14px;
  padding: 18px;
  border-radius: var(--radius);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: background .2s ease;
}

.promise-item:hover {
  background: rgba(255, 255, 255, 0.09);
}

.promise-marker {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  box-shadow: 0 0 12px rgba(79, 172, 254, 0.45);
  flex-shrink: 0;
  margin-top: 6px;
}

.promise-content h3 {
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 6px;
}

.promise-content p {
  font-size: 14px;
  line-height: 1.65;
  color: var(--text-faint);
  margin: 0;
}

/* 联系 */
.contact-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px;
  border-radius: var(--radius);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.contact-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(79, 172, 254, 0.14);
  color: #bfe3ff;
  flex-shrink: 0;
}

.contact-icon svg {
  width: 18px;
  height: 18px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.contact-label {
  font-size: 12px;
  color: var(--text-faint);
}

.contact-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
  word-break: break-word;
}

/* 页脚 */
.about-footer {
  text-align: center;
  font-size: 13px;
  color: var(--text-faint);
  padding-top: 16px;
}

/* 适龄提示 */
.age-summary {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.age-badge {
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: #fff;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.5px;
  box-shadow: 0 6px 18px rgba(79, 172, 254, 0.35);
}

.age-summary-text p {
  margin: 0;
  font-size: 14px;
  line-height: 1.7;
  color: var(--text);
}

.age-detail {
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 14px 16px;
}

.age-detail p {
  margin: 0 0 8px;
  font-size: 13px;
  line-height: 1.8;
  color: var(--text-dim);
}

.age-detail p:last-child {
  margin-bottom: 0;
}

.age-detail b {
  color: var(--brand);
}

/* 响应式 */
@media (max-width: 768px) {
  .about-page {
    padding: 28px 16px 48px;
  }

  .about-card {
    padding: 22px;
  }

  .company-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .promise-list {
    grid-template-columns: 1fr;
  }

  .contact-grid {
    grid-template-columns: 1fr;
  }

  .hero-title {
    font-size: 36px;
  }

  .title-accent {
    letter-spacing: 2px;
  }
}
</style>
